import { action, createRequestTypes } from '../base';

export const mrpV2ActionTypes = {
  CREATE_MRP_V2: createRequestTypes('CREATE_MRP_V2'),
  GET_MRP_V2: createRequestTypes('GET_MRP_V2'),
  GET_PRODUCTION_ITEMS: createRequestTypes('GET_PRODUCTION_ITEMS'),
  GET_STOCK_ITEMS: createRequestTypes('GET_STOCK_ITEM'),
  LINK_SO_TO_MRP: createRequestTypes('LINK_SO_TO_MRP'),
  PUSH_TO_PRODUCTION_ITEMS: createRequestTypes('PUSH_TO_PRODUCTION_ITEMS'),
  PUSH_TO_STOCK_ITEMS: createRequestTypes('PUSH_TO_STOCK_ITEMS'),
  UPDATE_MRP_V2: createRequestTypes('UPDATE_MRP_V2'),
  UPDATE_MRP_PRODUCTION: createRequestTypes('UPDATE_MRP_PRODUCTION'),
  GET_LINKED_MO: createRequestTypes('GET_LINKED_MO'),
  UPDATE_MRP_STOCK_ITEMS: createRequestTypes('UPDATE_MRP_STOCK_ITEMS'),
  LINK_MO_TO_MRP: createRequestTypes('LINK_MO_TO_MRP'),
  LINK_PO_TO_MRP: createRequestTypes('LINK_PO_TO_MRP'),
  UNLINK_SO_TO_MRP: createRequestTypes('UNLINK_SO_TO_MRP'),
  UNLINK_MO_TO_MRP: createRequestTypes('UNLINK_MO_TO_MRP'),
  UNLINK_PO_TO_MRP: createRequestTypes('UNLINK_PO_TO_MRP'),
  RESERVE_SHORTAGE: createRequestTypes('RESERVE_SHORTAGE'),
  CLOSE_MRP_PLAN: createRequestTypes('CLOSE_MRP_PLAN'),
  GET_MRP_SUMMARY: createRequestTypes('GET_MRP_SUMMARY'),
  CLEAR_RESERVATION: createRequestTypes('CLEAR_RESERVATION'),
  DELETE_MRP_V2: createRequestTypes('DELETE_MRP_V2'),
  GET_LINK_EXISTING_PO_TO_MRP: createRequestTypes('GET_LINK_EXISTING_PO_TO_MRP'),
  LINK_EXISTING_PO_TO_MRP: createRequestTypes('LINK_EXISTING_PO_TO_MRP'),
  GET_ALREADY_LINKED_PO_TO_MRP: createRequestTypes('GET_ALREADY_LINKED_PO_TO_MRP'),
  UNLINK_LINKED_PO_TO_MRP: createRequestTypes('UNLINK_LINKED_PO_TO_MRP'),
  UPDATE_LINKED_PO_TO_MRP: createRequestTypes('UPDATE_LINKED_PO_TO_MRP'),
};

/**
* @param payload
* @param callback
*/
class MrpV2Actions {
  // create Mrp v2
  createMrpV2 = (payload, callback) => action(mrpV2ActionTypes.CREATE_MRP_V2.REQUEST, {
    payload, callback,
  })

  createMrpV2Loading = (createMrpV2Loading) => action(mrpV2ActionTypes.CREATE_MRP_V2.LOADING, {
    createMrpV2Loading,
  })

  // get mrp v2
  getMrpV2 = (payload, callback) => action(mrpV2ActionTypes.GET_MRP_V2.REQUEST, {
    payload, callback,
  })

  getMrpV2Loading = (getMrpV2Loading) => action(mrpV2ActionTypes.GET_MRP_V2.LOADING, {
    getMrpV2Loading,
  })

  getMrpV2Success = (mrpV2) => action(mrpV2ActionTypes.GET_MRP_V2.SUCCESS, {
    mrpV2,
  })

  // Get Production Item
  getProductionItems = (mrpId, callback) => action(mrpV2ActionTypes.GET_PRODUCTION_ITEMS.REQUEST, {
    mrpId, callback,
  })

  getProductionItemsLoading = (getProductionItemsLoading) => action(mrpV2ActionTypes.GET_PRODUCTION_ITEMS.LOADING, {
    getProductionItemsLoading,
  })

  getProductionItemsSuccess = (productionItems) => action(mrpV2ActionTypes.GET_PRODUCTION_ITEMS.SUCCESS, {
    productionItems,
  })

  // Get Stock Item
  getStockItems = (payload, callback) => action(mrpV2ActionTypes.GET_STOCK_ITEMS.REQUEST, {
    payload, callback,
  })

  getStockItemsLoading = (getStockItemsLoading, entityType) => action(mrpV2ActionTypes.GET_STOCK_ITEMS.LOADING, {
    getStockItemsLoading,
    entityType,
  })

  getStockItemsSuccess = (stockItems, entityType) => action(mrpV2ActionTypes.GET_STOCK_ITEMS.SUCCESS, {
    stockItems,
    entityType,
  })

  // link so to Mrp
  LinkSoToMRP = (payload, callback) => action(mrpV2ActionTypes.LINK_SO_TO_MRP.REQUEST, {
    payload, callback,
  })

  LinkSoToMRPLoading = (LinkSoToMRPLoading) => action(mrpV2ActionTypes.LINK_SO_TO_MRP.LOADING, {
    LinkSoToMRPLoading,
  })

  // Push To Production Items
  pushToProductionItems = (payload, callback) => action(mrpV2ActionTypes.PUSH_TO_PRODUCTION_ITEMS.REQUEST, {
    payload, callback,
  })

  pushToProductionItemsLoading = (pushToProductionItemsLoading) => action(mrpV2ActionTypes.PUSH_TO_PRODUCTION_ITEMS.LOADING, {
    pushToProductionItemsLoading,
  })

  // Push To Stock Items
  pushToStockItems = (payload, callback) => action(mrpV2ActionTypes.PUSH_TO_STOCK_ITEMS.REQUEST, {
    payload, callback,
  })

  pushToStockItemsLoading = (pushToStockItemsLoading) => action(mrpV2ActionTypes.PUSH_TO_STOCK_ITEMS.LOADING, {
    pushToStockItemsLoading,
  })

  // update Mrp v2
  updateMrpV2 = (payload, callback) => action(mrpV2ActionTypes.UPDATE_MRP_V2.REQUEST, {
    payload, callback,
  })

  updateMrpV2Loading = (updateMrpV2Loading) => action(mrpV2ActionTypes.UPDATE_MRP_V2.LOADING, {
    updateMrpV2Loading,
  })

  // Update MRP Production
  updateMrpProduction = (payload, callback) => action(mrpV2ActionTypes.UPDATE_MRP_PRODUCTION.REQUEST, {
    payload, callback,
  })

  updateMrpProductionLoading = (updateMrpProductionLoading) => action(mrpV2ActionTypes.UPDATE_MRP_PRODUCTION.LOADING, {
    updateMrpProductionLoading,
  })

  // Get Linked MOs
  getLinkedMO = (payload, callback) => action(mrpV2ActionTypes.GET_LINKED_MO.REQUEST, {
    payload, callback,
  })

  getLinkedMOLoading = (getLinkedMOLoading) => action(mrpV2ActionTypes.GET_LINKED_MO.LOADING, {
    getLinkedMOLoading,
  })

  getLinkedMOSuccess = (linkedMO) => action(mrpV2ActionTypes.GET_LINKED_MO.SUCCESS, {
    linkedMO,
  })

  // update Mrp stock items
  updateMrpStockItems = (payload, callback) => action(mrpV2ActionTypes.UPDATE_MRP_STOCK_ITEMS.REQUEST, {
    payload, callback,
  })

  updateMrpStockItemsLoading = (updateMrpStockItemsLoading) => action(mrpV2ActionTypes.UPDATE_MRP_STOCK_ITEMS.LOADING, {
    updateMrpStockItemsLoading,
  })

  // Link Mo to Mrp
  linkMoToMrp = (payload, callback) => action(mrpV2ActionTypes.LINK_MO_TO_MRP.REQUEST, {
    payload, callback,
  })

  linkMoToMrpLoading = (linkMoToMrpLoading) => action(mrpV2ActionTypes.LINK_MO_TO_MRP.LOADING, {
    linkMoToMrpLoading,
  })

  // Link Po to Mrp
  linkPoToMrp = (payload, callback) => action(mrpV2ActionTypes.LINK_PO_TO_MRP.REQUEST, {
    payload, callback,
  })

  linkPoToMrpLoading = (linkPoToMrpLoading) => action(mrpV2ActionTypes.LINK_PO_TO_MRP.LOADING, {
    linkPoToMrpLoading,
  })

  // unlink so to Mrp
  unlinkSoToMrp = (payload, callback) => action(mrpV2ActionTypes.UNLINK_SO_TO_MRP.REQUEST, {
    payload, callback,
  })

  unlinkSoToMrpLoading = (unlinkSoToMrpLoading) => action(mrpV2ActionTypes.UNLINK_SO_TO_MRP.LOADING, {
    unlinkSoToMrpLoading,
  })

  // unlink mo to Mrp
  unlinkMoToMrp = (payload, callback) => action(mrpV2ActionTypes.UNLINK_MO_TO_MRP.REQUEST, {
    payload, callback,
  })

  unlinkMoToMrpLoading = (unlinkMoToMrpLoading) => action(mrpV2ActionTypes.UNLINK_MO_TO_MRP.LOADING, {
    unlinkMoToMrpLoading,
  })

  unlinkPoToMrp = (payload, callback) => action(mrpV2ActionTypes.UNLINK_PO_TO_MRP.REQUEST, {
    payload, callback,
  })

  unlinkPoToMrpLoading = (unlinkPoToMrpLoading) => action(mrpV2ActionTypes.UNLINK_PO_TO_MRP.LOADING, {
    unlinkPoToMrpLoading,
  })

  // Reserve Shortage
  reserveShortageMrp = (payload, callback) => action(mrpV2ActionTypes.RESERVE_SHORTAGE.REQUEST, {
    payload, callback,
  })

  reserveShortageMrpLoading = (reserveShortageMrpLoading) => action(mrpV2ActionTypes.RESERVE_SHORTAGE.LOADING, {
    reserveShortageMrpLoading,
  })

  // close mrp plan
  closeMrpPlan = (payload, callback) => action(mrpV2ActionTypes.CLOSE_MRP_PLAN.REQUEST, {
    payload, callback,
  })

  closeMrpPlanLoading = (closeMrpPlanLoading) => action(mrpV2ActionTypes.CLOSE_MRP_PLAN.LOADING, {
    closeMrpPlanLoading,
  })

  /**
   *
   * @param payload
   * @param callback
   * @returns {{type: *}}
   */
  getMrpSummary = (payload, callback) => action(mrpV2ActionTypes.GET_MRP_SUMMARY.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param getMrpSummaryLoading
   * @returns {{type: *}}
   */
  getMrpSummaryLoading = (getMrpSummaryLoading) => action(mrpV2ActionTypes.GET_MRP_SUMMARY.LOADING, {
    getMrpSummaryLoading,
  })

  getMrpSummarySuccess = (mrpSummary) => action(mrpV2ActionTypes.GET_MRP_SUMMARY.SUCCESS, {
    mrpSummary,
  })

  // Clear Reservation
  clearReservation = (payload, callback) => action(mrpV2ActionTypes.CLEAR_RESERVATION.REQUEST, {
    payload, callback,
  })

  clearReservationLoading = (clearReservationLoading) => action(mrpV2ActionTypes.CLEAR_RESERVATION.LOADING, {
    clearReservationLoading,
  })

  /**
   *
   * @param payload
   * @param callback
   * @returns {{type: *}}
   */
  deleteMrpV2 = (payload, callback) => action(mrpV2ActionTypes.DELETE_MRP_V2.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param deleteMrpV2Loading
   * @returns {{type: *}}
   */
  deleteMrpV2Loading = (deleteMrpV2Loading) => action(mrpV2ActionTypes.DELETE_MRP_V2.LOADING, {
    deleteMrpV2Loading,
  })

  // link existing po to mrp
  getLinkExistingPoToMrp = (payload, callback) => action(mrpV2ActionTypes.GET_LINK_EXISTING_PO_TO_MRP.REQUEST, {
    payload, callback,
  })

  getLinkExistingPoToMrpLoading = (getLinkExistingPoToMrpLoading) => action(mrpV2ActionTypes.GET_LINK_EXISTING_PO_TO_MRP.LOADING, {
    getLinkExistingPoToMrpLoading,
  })

  getLinkExistingPoToMrpSuccess = (getLinkPoToMrp) => action(mrpV2ActionTypes.GET_LINK_EXISTING_PO_TO_MRP.SUCCESS, {
    getLinkPoToMrp,
  })

  LinkExistingPoToMrpV2 = (payload, callback) => action(mrpV2ActionTypes.LINK_EXISTING_PO_TO_MRP.REQUEST, {
    payload, callback,
  })

  LinkExistingPoToMrpV2Loading = (LinkExistingPoToMrpV2Loading) => action(mrpV2ActionTypes.LINK_EXISTING_PO_TO_MRP.LOADING, {
    LinkExistingPoToMrpV2Loading,
  })

  getAlreadyLinkedPoToMrp = (payload, callback) => action(mrpV2ActionTypes.GET_ALREADY_LINKED_PO_TO_MRP.REQUEST, {
    payload, callback,
  })

  getAlreadyLinkedPoToMrpLoading = (getAlreadyLinkedPoToMrpLoading) => action(mrpV2ActionTypes.GET_ALREADY_LINKED_PO_TO_MRP.LOADING, {
    getAlreadyLinkedPoToMrpLoading,
  })

  getAlreadyLinkedPoToMrpSuccess = (getAlreadyLinkedPoToMrp) => action(mrpV2ActionTypes.GET_ALREADY_LINKED_PO_TO_MRP.SUCCESS, {
    getAlreadyLinkedPoToMrp,
  })

  unlinkLinkedPoToMrp = (payload, callback) => action(mrpV2ActionTypes.UNLINK_LINKED_PO_TO_MRP.REQUEST, {
    payload, callback,
  })

  unlinkLinkedPoToMrpLoading = (unlinkLinkedPoToMrpLoading) => action(mrpV2ActionTypes.UNLINK_LINKED_PO_TO_MRP.LOADING, {
    unlinkLinkedPoToMrpLoading,
  })

  updateLinkedPoToMrp = (payload, callback) => action(mrpV2ActionTypes.UPDATE_LINKED_PO_TO_MRP.REQUEST, {
    payload, callback,
  })

  updateLinkedPoToMrpLoading = (updateLinkedPoToMrpLoading) => action(mrpV2ActionTypes.UPDATE_LINKED_PO_TO_MRP.LOADING, {
    updateLinkedPoToMrpLoading,
  })
}

export default new MrpV2Actions();
